import { Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {

  constructor(private toastrService: ToastrService) {
  }


  public info(message: string, title: string = 'information', timeout = 5000): void {
    this.toastrService.info(message, title,
      {
        timeOut: timeout
      });
  }

  public success(message: string, title: string = 'success', timeout = 5000): void {
    this.toastrService.success(message, title,
      {
        timeOut: timeout
      });
  }

  public warning(message: string, title: string = 'warning', timeout = 5000): void {
    this.toastrService.warning(message, title,
      {
        timeOut: timeout
      });
  }

  public error(message: string, title: string = 'error', timeout = 5000): void {
    this.toastrService.error(message, title,
      {
        timeOut: timeout
    });
  }
}
